import axiosClient from "./axiosClient";

const productApi = {
  search: (
    searchKeyword,
    page,
    pageSize,
    productType,
    supplierId,
    productGroupNo,
  ) => {
    return axiosClient.post(
      "/price_list/search",
      {
        searchKeyword: searchKeyword,
        pageNumber: page > 0 ? page + 1 : 1,
        pageSize: pageSize,
        productType: productType,
        supplierId: supplierId,
        productGroupNo: productGroupNo,
      },
      { withCredentials: true },
    );
  },
  getProductGroup: (productType, supplierId) => {
    return axiosClient.post(
      `/price_list/get-product-group`,
      {
        productType: productType,
        supplierId: supplierId,
      },
      { withCredentials: true },
    );
  },

  upsert: (productData) => {
    return axiosClient.post("/price_list/upsert", productData, {
      withCredentials: true,
    });
  },

  delete: (priceListId) => {
    return axiosClient.delete(`/price_list/${priceListId}`, {
      withCredentials: true,
    });
  },
  get: (priceListId) => {
    return axiosClient.get(`/price_list/${priceListId}`, {
      withCredentials: true,
    });
  },
};

export default productApi;
